// extracted by mini-css-extract-plugin
export var chevron = "_co-4";
export var chevronExpanded = "_co-5";
export var row = "_co-0";
export var rowBody = "_co-6";
export var rowDescription = "_co-7";
export var rowHeader = "_co-1";
export var rowTitle = "_co-2";
export var rowTitleComplete = "_co-3";